import type { Editor } from "@tiptap/react";

import type { VirtualRectAnchor } from "./types";

export const buildSelectionAnchor = (
  editor: Editor,
): VirtualRectAnchor | null => {
  if (!editor.view) return null;

  try {
    const { from, to } = editor.state.selection;
    const start = editor.view.coordsAtPos(from);
    const end = editor.view.coordsAtPos(to);
    const top = Math.min(start.top, end.top);
    const bottom = Math.max(start.bottom, end.bottom);
    const left = Math.min(start.left, end.left);
    const right = Math.max(start.right, end.right);
    const width = Math.max(right - left, 1);
    const height = Math.max(bottom - top, 1);

    return {
      getBoundingClientRect: () =>
        ({
          x: left,
          y: top,
          top,
          left,
          right,
          bottom,
          width,
          height,
          toJSON() {
            return this;
          },
        }) as DOMRect,
    };
  } catch {
    return null;
  }
};
